import { useEffect } from 'react'
import { Box, Container, Flex } from 'pcln-design-system'
import { useContentfulWithPredicate } from '@pcln/contentful-components'
import PromoBanners from '@/components/MerchModuleWrapper/PromoBanners'
import AdBanner from '@/components/AdBanner'
import { AdBox, AdContent } from '@/components/AdContent'
import AppDownloadWrapper from '@/components/AppDownloadWrapper'
import EmailSignUp from '@/components/EmailSignUp'
import PackagesCarousel from '@/components/PackagesCarousel'
import { isCollectionOfIMerchModule } from '@/shared-utils/content-model-type-guards'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import { ActionCard } from '@pcln/cards'
import styled from 'styled-components'
import analytics from '@/shared-utils/analytics'
import actionCardsData from '../constants'

const StyledFlex = styled(Flex)`
  & > * {
    flex-basis: 100%;
  }
  & img {
    object-fit: cover;
  }
`

function Content() {
  const toutBanners = useContentfulWithPredicate(
    'toutBanners',
    isCollectionOfIMerchModule
  )
  const promoItems = toutBanners?.items || ([] as const)

  useEffect(() => {
    analytics.fireGA4Event({
      event: 'view_promotion',
      attributes: {
        type: 'marketing',
        bundle_flag: 'y',
        bundle_type: '',
        product_name: 'bundle',
        promotion_name: 'bundle',
        creative_name: 'package_promo',
        items: [
          {
            index: '1',
            item_name: 'bundle',
            item_id: 'actionCard'
          }
        ]
      }
    })
  }, [])
  return (
    <Container size="xl" mb={5}>
      <LayoutComponentWrapper>
        <StyledFlex
          mx={3}
          mb={4}
          style={{ gap: 16 }}
          flexDirection={['column', null, null, null, 'row']}
        >
          {actionCardsData.map(card => (
            <ActionCard key={card.heading} {...card} />
          ))}
        </StyledFlex>
      </LayoutComponentWrapper>
      <Box my={4}>
        <PackagesCarousel />
      </Box>
      <LayoutComponentWrapper>
        <AdContent>
          <AdBox type="primary">
            <div id="div-gpt-ad-1511924707554-0" />
          </AdBox>
          <AdBox type="secondary">
            <div id="div-gpt-ad-1511924575742-0" />
          </AdBox>
          <AdBox type="tertiary">
            <div id="div-gpt-ad-1511924174680-0" />
          </AdBox>
        </AdContent>
        <EmailSignUp appCode="DESKTOP" sourceId="LANDING_PACKAGE" />
        <PromoBanners merchModules={promoItems} />
        <AppDownloadWrapper />
        <AdBanner>
          <div id="div-gpt-ad-1511924263419-0" />
        </AdBanner>
      </LayoutComponentWrapper>
    </Container>
  )
}

export default Content
